var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#FFF5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8368 20.522L9.66683 12.3333H20.3335L19.1635 20.522C19.1181 20.8397 18.9596 21.1304 18.7171 21.3406C18.4746 21.5509 18.1644 21.6667 17.8435 21.6666H12.1568C11.8359 21.6667 11.5257 21.5509 11.2832 21.3406C11.0407 21.1304 10.8822 20.8397 10.8368 20.522ZM21.0002 9.66665H17.6668V8.99998C17.6668 8.82317 17.5966 8.6536 17.4716 8.52858C17.3465 8.40355 17.177 8.33331 17.0002 8.33331H13.0002C12.8234 8.33331 12.6538 8.40355 12.5288 8.52858C12.4037 8.6536 12.3335 8.82317 12.3335 8.99998V9.66665H9.00016C8.82335 9.66665 8.65378 9.73688 8.52876 9.86191C8.40373 9.98693 8.3335 10.1565 8.3335 10.3333C8.3335 10.5101 8.40373 10.6797 8.52876 10.8047C8.65378 10.9297 8.82335 11 9.00016 11H21.0002C21.177 11 21.3465 10.9297 21.4716 10.8047C21.5966 10.6797 21.6668 10.5101 21.6668 10.3333C21.6668 10.1565 21.5966 9.98693 21.4716 9.86191C21.3465 9.73688 21.177 9.66665 21.0002 9.66665Z",
    fill: "#F1416C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.13c529ce14a60c39e289a7107975f33a.svg";
export { ForwardRef as ReactComponent };